<template>
  <main id="main-container">
    <Hero title="Editar Plantilla" page="editar-plantilla" />

    <div class="content">
      <!-- WIDGET CONFIGURATOR -->
      <div class="row">
        <Card>
          <template v-slot:header>
            <h4 class="card-title">Actualizar Widgets</h4>
          </template>

          <div class="row">
            <!-- WIDGET SELECTOR AND FORMS -->
            <div class="col-md-6 col-sm-12">
              <!-- WIDGETS SELECTOR -->
              <label class="form-label" for="">Seleccionar Variable</label>
              <select
                v-model="widgetIndex"
                placeholder="Widget"
                class="form-select"
                style="width: 100%"
              >
                <option
                  v-for="(widget, index) in widgets"
                  :key="index"
                  class="text-dark"
                  :value="index"
                >
                  {{ widget.variableFullName }}
                </option>
              </select>

              <br />
              <!-- FORMS NUMBER CHART TYPE -->

              <div v-if="widgetIndex != null">
                <!-- NumberchartForm-->
                <NumberchartForm
                  v-if="widgets[widgetIndex].widget == 'numberchart'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :validateCount="validateCount"
                  :widgetType="widgets[widgetIndex].widget"
                >
                </NumberchartForm>

                <!-- FORM SWITCH TYPE -->
                <SwitchForm
                  v-if="widgets[widgetIndex].widget == 'switch'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgets[widgetIndex].widget"
                ></SwitchForm>

                <!-- Form setValue Indicator -->
                <SetIndicatorForm
                  v-if="widgets[widgetIndex].widget == 'setIndicator'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgets[widgetIndex].widget"
                  :validateCount="validateCount"
                ></SetIndicatorForm>

                <SliderForm
                  v-if="widgets[widgetIndex].widget == 'slider'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgets[widgetIndex].widget"
                  :validateCount="validateCount"
                >
                </SliderForm>

                <FuildLevelIdicatorForm
                  v-if="widgets[widgetIndex].widget == 'fluidLevel'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgets[widgetIndex].widget"
                  :validateCount="validateCount"
                >
                </FuildLevelIdicatorForm>

                <IndicatorForm
                  v-if="widgets[widgetIndex].widget == 'indicator'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgets[widgetIndex].widget"
                ></IndicatorForm>

                <!-- FORM VALUE INDICATOR TYPE -->

                <IndicatorValueForm
                  v-if="widgets[widgetIndex].widget == 'indicatorvalue'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgets[widgetIndex].widget"
                  :validateCount="validateCount"
                ></IndicatorValueForm>

                <OpenStreetMapsForm
                  v-if="widgets[widgetIndex].widget == 'open-streetmaps'"
                  :widgetConfig="widgets[widgetIndex]"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgets[widgetIndex].widget"
                ></OpenStreetMapsForm>

                <IotbuttonForm
                  v-if="widgets[widgetIndex].widget == 'button'"
                  :widgetConfig="widgetConfig"
                  :addNewWidget="addNewWidget"
                  :widgetType="widgetType"
                ></IotbuttonForm>
              </div>
            </div>
            <!-- WIDGET PREVIEW -->

            <div v-if="widgetIndex != null" class="col-md-6 col-sm-12">
              <Rtnumberchart
                v-if="widgetType == 'numberchart'"
                :config="widgetConfig"
              ></Rtnumberchart>

              <SetValueIndicator
                v-if="widgetType == 'setIndicator'"
                :config="widgetConfig"
              ></SetValueIndicator>

              <Iotswitch
                v-if="widgetType == 'switch'"
                :config="widgetConfig"
              ></Iotswitch>

              <Iotbutton
                v-if="widgetType == 'button'"
                :config="widgetConfig"
              ></Iotbutton>

              <Iotindicator
                v-if="widgetType == 'indicator'"
                :config="widgetConfig"
              ></Iotindicator>
              <Iotindicatorvalue
                v-if="widgetType == 'indicatorvalue'"
                :config="widgetConfig"
              ></Iotindicatorvalue>

              <OpenStreetMaps
                v-if="widgetType == 'open-streetmaps'"
                :config="widgetConfig"
              >
              </OpenStreetMaps>

              <IotSlider
                v-if="widgetType == 'slider'"
                :config="widgetConfig"
              ></IotSlider>

              <FluidLevelIndicator
                v-if="widgetType == 'fluidLevel'"
                :config="widgetConfig"
              >
              </FluidLevelIndicator>
            </div>
          </div>

          <!-- ADD WIDGET BUTTON -->
          <div class="row pull-right">
            <div class="col-12">
              <button
                native-type="submit"
                type="submit"
                class="btn btn-info"
                @click="updateTemplate"
              >
                Actualizar Plantilla
              </button>
            </div>
          </div>
        </Card>
      </div>

      <!-- DASHBOARD PREVIEW -->
      <div class="row">
        <div
          v-for="(widget, index) in widgets"
          :key="index"
          :class="[widget.column]"
        >
        <SetValueIndicator
            v-if="widget.widget == 'setIndicator'"
            :config="widget"
          ></SetValueIndicator>

          <Rtnumberchart
            v-if="widget.widget == 'numberchart'"
            :config="widget"
          ></Rtnumberchart>

          <Iotswitch
            v-if="widget.widget == 'switch'"
            :config="widget"
          ></Iotswitch>

          <Iotbutton
            v-if="widget.widget == 'button'"
            :config="widget"
          ></Iotbutton>

          <Iotindicator
            v-if="widget.widget == 'indicator'"
            :config="widget"
          ></Iotindicator>

          <Iotindicatorvalue
            v-if="widget.widget == 'indicatorvalue'"
            :config="widget"
          ></Iotindicatorvalue>

          <OpenStreetMaps
            v-if="widget.widget == 'open-streetmaps'"
            :config="widget"
          ></OpenStreetMaps>
          <IotSlider v-if="widget.widget == 'slider'" :config="widget">
          </IotSlider>

          <FluidLevelIndicator
            v-if="widget.widget == 'fluidLevel'"
            :config="widget"
          >
          </FluidLevelIndicator>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Card from "@/components/Cards/Card.vue";
import useApp from "@/composables/useApp";
import {
  IotbuttonForm,
  NumberchartForm,
  SwitchForm,
  SetIndicatorForm,
  IndicatorForm,
  IndicatorValueForm,
  OpenStreetMapsForm,
  SliderForm,
  FuildLevelIdicatorForm,
} from "@/components/Templates/index";
import {
  Rtnumberchart,
  Iotindicatorvalue,
  SetValueIndicator,
  Iotswitch,
  Iotindicator,
  OpenStreetMaps,
  Iotbutton,
  IotSlider,
  FluidLevelIndicator,
} from "@/components/Widgets/index";

export default {
  components: {
    Rtnumberchart,
    Iotindicatorvalue,
    SetValueIndicator,
    Iotswitch,
    Iotindicator,
    OpenStreetMaps,
    Iotbutton,
    IotSlider,
    FluidLevelIndicator,
    Card,
    IotbuttonForm,
    NumberchartForm,
    SwitchForm,
    SetIndicatorForm,
    IndicatorForm,
    IndicatorValueForm,
    OpenStreetMapsForm,
    SliderForm,
    FuildLevelIdicatorForm,
  },
  data() {
    return {
      widgets: [],
      widgetIndex: null,
      templateId: "",
    };
  },

  mounted() {
    const {
      ToastMsg,
      ToastMsgError,
      ToastMsgWarning,
      ToastMsgInfo,
      ToastMsgSuccess,
    } = useApp();
    this.ToastMsg = ToastMsg;
    this.ToastMsgError = ToastMsgError;
    this.ToastMsgInfo = ToastMsgInfo;
    //this.widgets = this.$store.state.selectedDevice.template.widgets;
    setTimeout(() => {
      if (this.$store.state.selectedDevice.template != undefined) {
        this.widgets = this.$store.state.selectedDevice.template.widgets;
        this.templateId = this.$store.state.selectedDevice.templateId;
      }
    }, 100);

    //this.getTemplates();
  },

  methods: {
    validateCount(obj) {
      if (obj.decimalPlaces > 5) {
        obj.decimalPlaces = 5;
      } else if (obj.decimalPlaces < 1) {
        obj.decimalPlaces = 1;
      }
    },
    //Save Template
    async updateTemplate() {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      const toSend = {
        templateId: this.templateId,
        widgets: this.widgets,
      };

      try {
        const res = await this.$axios.put("/template", toSend, axiosHeaders);

        if (res.data.status == "success") {
          this.ToastMsgInfo("Plantilla Actualizada!", "cloud", 5000);
        }
      } catch (error) {
        this.ToastMsgError(
          "Error al Intentar Actualizar la Plantilla",
          "cloud",
          5000
        );
        console.log(error);

        return;
      }
    },
  },
};
</script>
